import { styled } from '@mui/system'
import { motion } from 'framer-motion'
import { TTheme } from '@/core/theme'

export const SectionWrapper = styled(motion.div)<{ theme?: TTheme }>`
    background: ${({ theme }) => theme?.colors?.semantic?.backgroundSecondary};
    border-radius: 16px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
    width: 336px;
    max-height: 480px;
    display: flex;
    flex-direction: column;
    z-index: 1100;
    overflow: hidden;
    padding-top: 20px;
`

export const SectionsContainer = styled('div')`
    flex: 1;
    overflow-y: auto;
    & > :last-child {
        padding-bottom: 24px;
    }
`

export const PopupContainer = styled(motion.div)<{
    theme?: TTheme
}>`
    position: absolute;
    top: 54px;
    left: 0;
    z-index: 1100;
`

export const popupVariants = {
    hidden: {
        opacity: 0,
        scale: 0.98,
        y: -5,
    },
    visible: {
        opacity: 1,
        scale: 1,
        y: 0,
        transition: {
            duration: 0.2,
            ease: [0.25, 0.46, 0.45, 0.94],
        },
    },
    exit: {
        opacity: 0,
        scale: 0.98,
        y: -5,
        transition: {
            duration: 0.15,
            ease: [0.55, 0.055, 0.675, 0.19],
        },
    },
}

export const sectionVariants = {
    hidden: {
        opacity: 0,
        y: 10,
    },
    visible: (i: number) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.03,
            duration: 0.3,
            ease: [0.25, 0.46, 0.45, 0.94],
        },
    }),
    exit: {
        opacity: 0,
        y: 10,
        transition: {
            duration: 0.2,
            ease: [0.55, 0.055, 0.675, 0.19],
        },
    },
}

export const footerVariants = {
    hidden: {
        opacity: 0,
        y: 5,
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            delay: 0.15,
            duration: 0.3,
            ease: [0.25, 0.46, 0.45, 0.94],
        },
    },
    exit: {
        opacity: 0,
        y: 5,
        transition: {
            duration: 0.2,
            ease: [0.55, 0.055, 0.675, 0.19],
        },
    },
}

export const Section = styled('div')<{ theme?: TTheme }>`
    padding: 0 24px;

    .section-title {
        text-transform: uppercase;
        letter-spacing: 1.8px;
    }
`

export const HorizontalSeparator = styled('div')`
    display: flex;
    justify-content: center;
    padding: 12px 0;
`

export const SectionHeader = styled('div')<{
    theme?: TTheme
    collapsed?: boolean
}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin-bottom: 8px;
    user-select: none;
`

export const SectionLabel = styled('span')<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors?.greys[600]};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1.2px;
`

export const OptionsList = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const OptionRow = styled('label')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 4px 0;

    .MuiCheckbox-root {
        .atb-lib-checkbox-unchecked {
            background-color: ${({ theme: { colors } }) =>
                colors.greys[100]} !important;
        }
    }
`

export const Footer = styled('div')<{ theme?: TTheme }>`
    background: ${({ theme }) =>
        theme?.colors?.semantic.filterPopupFooterBackground};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px 16px 24px;
    gap: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
`

export const CancelButton = styled('button')<{ theme?: TTheme }>`
    border: 1px solid ${({ theme }) => theme?.colors?.primary[200]};
    background: ${({ theme }) => theme?.colors?.greys[50]};
    color: ${({ theme }) => theme?.colors?.primary[200]};
    border-radius: 24px;
    cursor: pointer;
    padding: 6px 24px;
`

export const ApplyButton = styled('button')<{ theme?: TTheme }>`
    border: 1px solid ${({ theme }) => theme?.colors?.primary[200]};
    background: ${({ theme }) => theme?.colors?.greys[50]};
    color: ${({ theme }) => theme?.colors?.primary[200]};
    border-radius: 24px;
    cursor: pointer;
    padding: 6px 24px;
    &:hover {
        background: ${({ theme }) => theme?.colors?.primary[50]};
    }
`
